import { post, get } from '../../../../services/request';

// Get All Site Alias Detail
export const getAllSiteAliasDetail = (value = false) => {
    return get(`SiteAliasDetail/GetAllSiteAliasDetail?=${value}`);
};

// Get All Sites for Site Alias Management
export const getAllSitesListforAlias = () => {
    return get('SiteManagement/GetAllSitesDropDownList?loadAllSites=true');
};

// Bulk Save Site Alias Management
export const bulksaveSiteAliasManagement = (data) => {
    return post('SiteAliasDetail/BulkUpdateSiteAliasDetail', data);
}

// Get Site Alias Management Details History
export const getSiteAliasManagementDetailsHistory = (id) => {
    return get(`SiteAliasDetail/GetSiteAliasDetailHistoryByID?SiteAliasDetailID=${id}`);
};

// Activate/Deactivate Site Alias Management
export const activateDeactivateSiteAlias = (Id, status, userId) => {
    return post('SiteAliasDetail/ActivateDeactivate', {Id,status,userId
    });
};

// Export Site Alias Management Data
export const ExportSiteAlias = () => {
    return get('SiteAliasDetail/ExportToCSV');
};
